import * as types from '../../actions/ActionTypes';

const INITIAL_STATE = {
    isFetching: false,
    selectedTab: 1,
    reportDialog: {
        open: false,
        submitting: false,
        reviewStatus: null
    }
};

const setProfilePageSelectedTab = (state, action) => {
    return {
        ...state,
        selectedTab: action.selectedTab
    };
};

const setReportDialog = (state, action) => {
    return {
        ...state,
        reportDialog: {
            open: action.open,
            submitting: action.submitting,
            reviewStatus: action.reviewStatus
        }
    };
};

const resetToInitialState = () => INITIAL_STATE;

const handlers = {
    SELECT_PROFILE_PAGE_TAB: setProfilePageSelectedTab,
    [types.PROFILE_PAGE_REPORT_SET_REPORT_DIALOG]: setReportDialog,
    [types.RESET_PROFILE_PAGE]: resetToInitialState
};

export const getProfilePage = (state) => state.profilePage;

export const selectProfilePageReportDialogState = (state) => {
    const profilePage = getProfilePage(state);
    return profilePage.reportDialog;
};

export default function profilePage(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
